/** Contact page copy and form options. */

export const SERVICE_OPTIONS = [
  {
    id: "receptionist",
    label: "AI receptionist (phone)",
    description: "24/7 answering, leads, and handoffs",
  },
  {
    id: "ai-chat",
    label: "AI chat for your website",
    description: "Grounded answers from your docs and data",
  },
  {
    id: "unifi-networks",
    label: "UniFi networks",
    description: "Installs, Wi‑Fi, VLANs, VPN, cameras",
  },
  {
    id: "custom-sites",
    label: "Custom websites & apps",
    description: "Fast sites and apps you own",
  },
  {
    id: "support",
    label: "Ongoing support",
    description: "Monitoring, fixes, and retainers",
  },
  {
    id: "not-sure",
    label: "Not sure yet",
    description: "Help me choose the right fit",
  },
];

export const TIMELINE_OPTIONS = [
  { value: "", label: "Select timeline (optional)" },
  { value: "asap", label: "As soon as possible" },
  { value: "2-weeks", label: "Within 2 weeks" },
  { value: "1-month", label: "Within a month" },
  { value: "exploring", label: "Just exploring options" },
];

export const PREFERRED_CONTACT_OPTIONS = [
  { value: "either", label: "Email or phone - either works" },
  { value: "email", label: "Email preferred" },
  { value: "phone", label: "Phone preferred" },
];

export const contactContent = {
  eyebrow: "Contact",
  title: "Tell us what you're building.",
  lead:
    "Share a few details and we'll follow up - often with a quick AI-assisted reply first, then a real person for scheduling and scope.",
  supportUpsell: {
    title: "Add ongoing support",
    body:
      "Already have UniFi, a site, or AI in place? Ask about monitoring, ticket-based support, and predictable monthly care - same team that installs it.",
    checkboxLabel: "I'd like information on ongoing support plans",
  },
  consents: {
    marketing:
      "Yes - send me occasional updates, tips, and offers from AI & Computer Services. I can unsubscribe anytime.",
    aiRecording:
      "I consent to AI-assisted phone or chat communication (which may include recording or transcription where permitted) so you can respond to my request.",
    sms:
      "I agree to receive SMS messages from AICSNetworks related to my inquiry, including customer service, appointment coordination, support requests, lead intake, and follow-up messages. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not required to purchase services.",
  },
  success: {
    title: "Message received",
    body:
      "We saved your request and sent a confirmation to your email. A team member - or our AI assistant when appropriate - will reach out with next steps soon.",
    again: "Send another message",
  },
  submitLabel: "Send message",
  submittingLabel: "Sending…",
};
